module.exports = __webpack_public_path__ + "img/spain.4bd7d035.svg";